import { Navigate, useRoutes } from "react-router-dom";
// layouts
import DashboardLayout from "./layouts/dashboard";
import SimpleLayout from "./layouts/simple";
//
import BlogPage from "./pages/BlogPage";
import GamePage from "./pages/GamePage";
import UserPage from "./pages/UserPage";
import LoginPage from "./pages/LoginPage";
import Page404 from "./pages/Page404";
import ProductsPage from "./pages/ProductsPage";
import DashboardAppPage from "./pages/DashboardAppPage";
import NewGamePage from "./pages/NewGamePage";
import GameQuestionsPage from "./pages/GameQuestionsPage";
import GameUsersPage from "./pages/GameUsersPage";
import GameUserCardPage from "./pages/GameUserCardPage";
import GameEditPage from "./pages/GameEditPage";
import GameQuestionCreatePage from "./pages/GameQuestionCreatePage";
import GameResultsPage from "./pages/GameResultsPage";
import QuestionTemplatesPage from "./pages/QuestionTemplatesPage";
import GameCodesPage from "./pages/GameCodesPage";
import StatsPage from "./pages/StatsPage";
import NewCustomGamePage from "./pages/NewCustomGamePage";
import PagesList from "./pages/PagesList";
import PageEditPage from "./pages/PageEditPage";
import HeadshotsFoldersPage from "./pages/HeadshotsFoldersPage";
import HeadshotsPage from "./pages/HeadshotsPage";

// ----------------------------------------------------------------------

export default function Router() {
  const routes = useRoutes([
    {
      path: "/dashboard",
      element: <DashboardLayout />,
      children: [
        { element: <Navigate to="/dashboard/games" />, index: true },
        { path: "games", element: <GamePage /> },
        { path: "stats", element: <StatsPage /> },
        { path: "new-game", element: <NewGamePage /> },
        { path: "new-custom-game", element: <NewCustomGamePage /> },
        { path: "question-templates", element: <QuestionTemplatesPage /> },
        { path: "game/edit", element: <GameEditPage /> },
        { path: "game/questions", element: <GameQuestionsPage /> },
        { path: "game/questions/create", element: <GameQuestionCreatePage /> },
        { path: "game/users", element: <GameUsersPage /> },
        { path: "game/results", element: <GameResultsPage /> },
        { path: "game/user-card", element: <GameUserCardPage /> },
        { path: "game/codes", element: <GameCodesPage /> },
        { path: "app", element: <DashboardAppPage /> },
        { path: "user", element: <UserPage /> },
        { path: "products", element: <ProductsPage /> },
        { path: "blog", element: <BlogPage /> },
        { path: "pages", element: <PagesList /> },
        { path: "pages/edit", element: <PageEditPage /> },
        { path: "headshots", element: <HeadshotsFoldersPage /> },
        { path: "headshots/:id", element: <HeadshotsPage /> },
      ],
    },
    {
      path: "login",
      element: <LoginPage />,
    },
    {
      element: <SimpleLayout />,
      children: [
        { element: <Navigate to="/dashboard/games" />, index: true },
        { path: "404", element: <Page404 /> },
        { path: "*", element: <Navigate to="/404" /> },
      ],
    },
    {
      path: "*",
      element: <Navigate to="/404" replace />,
    },
  ]);

  return routes;
}
